import I18n from 'I18n';
import { VerticalMenuIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ReportActionsDropdownButton(buttonProps) {
  return /*#__PURE__*/_jsx(IconButton, Object.assign({
    "data-test-id": "report-actions-button",
    "aria-label": I18n.text('reporting-enablement.reportCardV2.reportActions.dropdownButton')
  }, buttonProps, {
    children: /*#__PURE__*/_jsx(VerticalMenuIcon, {})
  }));
}